require('./brokerStocksAdvancedBuyExanteCost.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @helpers
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require('utilities/currencyHelper');

// @ components
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const { OKLink } = require('commonsComponents/OKLink');
const BrokerExanteProfitabilityCosts = require("components/commons/brokerExanteProfitabilityCosts/brokerExanteProfitabilityCosts");
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');


// @ constants
const {
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    CHARGE_ACCOUNT_PREFIX,
    POTENTIAL_SELL_STOCKS_COSTS,
    POTENTIAL_COST,
    POTENTIAL_COST_TYPE,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_INDEX_ORDER_CONDITION_VALUE,
    BROKER_RESTRICTED_ORDER_TERM,
    BROKER_STOCK_ORDER_CONDITION_VALUE,
    BROKER_INPUT_SEARCH_STOCKS_TYPE,
    BROKER_IBEX35_STOCK_MARKET_NAME,
    BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID,
    BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    MAX_FRACTION_LENGTH_IN_STORE
} = require("constants/index");

class BrokerStocksAdvancedBuyExanteCost extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('broker-stocksBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('broker-stocksBuyStep1ForTheBestLabel');
        } else {
            return formatText('broker-stocksBuyStep1LimitedLabel');
        }
    }

    buildLeftColumn() {
        const {immProductFile, immBrokerStocksAdvancedBuy, immStocksContract} = this.props;
        const PREFIX = 'brokerBuyAdvancedStockExAnte-';

        const companyName = immProductFile.get('companyName');
        const marketCode = immProductFile.get('marketCode');
        const marketInfo = `${companyName} (${marketCode})`

        const immStepTwo = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
        const selectedOption = immStepTwo.get('selectedOptionValue');
        const selectedAccount = immStocksContract.get(selectedOption);
        const accountOwner = selectedAccount.get('firstTitular');
        const productNumber = selectedAccount.get('productNumber');
        const contractNumber = selectedAccount.get('walletNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const accountName = selectedAccount.get('associatedAccountAlias');
        const accountNumber = selectedAccount.get('associatedAccount');
        const walletBalance = selectedAccount.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = selectedAccount.getIn(['associatedAccountBalance', 'currency']);
        const balanceLabel = formatText(`${PREFIX}balanceLabel`);

        let estimatedAmount = `${formatWithoutRound(walletBalance)} ${formatCurrency(walletCurrency)}`;
        const dataExtant = immBrokerStocksAdvancedBuy.get('exAnteData');
        const estimatedBaseAmount = !!dataExtant && dataExtant.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = !!dataExtant && dataExtant.get('estimatedBaseAmountExchanged');
        if(!!estimatedBaseAmount){
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue=estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency=estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }

        const titles = immBrokerStocksAdvancedBuy.getIn(['validationServiceResponse' ,'ntitulos'])

        const orderType = immStepTwo.get('orderTypeOption');
        const orderTypeText = this.getOrderType(orderType);

        const dateFormat = formatText('broker-stocksLikeHeaderDateFormat');
        const validityDate = immStepTwo.get('validityDate').format(dateFormat);

        const descriptionAccount = `${accountName} ${accountNumber} (${balanceLabel} ${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)})`

        return (
            <div className="broker-buy-stock-advanced-description__left-column-container">
                <div className="broker-buy-stock-advanced-description__column-title">
                    <FormattedText value="brokerBuyStockExtantCost-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label={`${PREFIX}stockTitleLabel`}
                    data={marketInfo}
                />
                <BrokerDataItem
                    label={`${PREFIX}estimatedAmount`}
                    data={estimatedAmount}
                    tooltipTitleKey={`brokerBuyAdvancedStockExAnte-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerBuyAdvancedStockExAnte-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra acciones/paso 2"
                    eventTag={"orden de compra/importe base estimado"}
                    complexTooltip
                />
                <BrokerDataItem
                    label={`${PREFIX}titlesLabel`}
                    data={titles}
                />
                <BrokerDataItem
                    label={`${PREFIX}stockTypeTitle`}
                    data={orderTypeText}
                />
                <BrokerDataItem
                    label={`${PREFIX}validityLabel`}
                    data={validityDate}
                />
                <BrokerDataItem
                    label={`${PREFIX}contractTitleLabel`}
                    data={chargeAccount}
                />
                <BrokerDataItem
                    label={`${PREFIX}firstOwnerLabel`}
                    data={accountOwner}
                />
                <BrokerDataItem
                    label={`${PREFIX}associateAccountLabel`}
                    data={descriptionAccount}
                />
            </div>
        );
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    buildModalContent(profitabilityData) {
        return(
            <div>
                <h3>
                    <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_modalTitle" />
                </h3>
                <p>
                    <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_modalContent1" />
                </p>
                <p>
                    <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_modalContent2" />
                </p>
                <p>
                    <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_modalContent3" />
                </p>
                <div className="broker-buy-stock-advanced-description__profitability-container">
                    <BrokerExanteProfitabilityCosts
                        context="brokerBuyStockExAnteProfitability"
                        section={profitabilityData.merge({
                                hidden: false,
                                type: 'SECTION'
                        })}
                    />
                </div>
                <p>
                    <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_modalFooter" />
                </p>
            </div>
        )
    }

    buildProfitabilitySection(profitabilityData) {
        const link = (
            <OKLink
                modifier="emphasize"
                onClick={() => this.handleToggleModal()}
                extraClass="broker-buy-stock-advanced-description__description-link"
            >
                <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_descriptionLink" />
            </OKLink>
        );
        const modalContent = this.buildModalContent(profitabilityData)
        const totalProfitability = !!profitabilityData.get('total')
            ? !!profitabilityData.getIn(['total', 'percentage'])
                ? formatPercentage(profitabilityData.getIn(['total', 'percentage']))
                : '0'
            : '0'
        return(
            <div>
                <OKModal
                    content={modalContent}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                    footerType="navigation"
                    size="large"
                    primaryButtonText="brokerBuyAdvancedStockExAnte-profitabilitySection_modalButton"
                    onPrimaryButtonClick={this.handleToggleModal}
                />
                <div>
                    <p className="broker-buy-stock-advanced-description__column-title">
                        <FormattedText value="brokerBuyAdvancedStockExAnte-profitabilitySection_title" />
                    </p>
                    <p className="broker-buy-stock-advanced-description__description">
                        <FormattedTextWithComponents
                            value="brokerBuyAdvancedStockExAnte-profitabilitySection_description"
                            injectedComponents={[totalProfitability, link]}
                        />
                    </p>
                </div>
            </div>
        )
    }

    buildRightColumn() {
        const { immBrokerStocksAdvancedBuy, showProfitabilitySection } = this.props;
        const exAnteData = immBrokerStocksAdvancedBuy.getIn(['exAnteData']);
        const exAnteCostList = !!exAnteData && exAnteData.getIn(['exAnteCostList']);
        let data, profitabilitySection, potentialSellStocksCostsText;
        if (immBrokerStocksAdvancedBuy.get('exAnteFetching')) {
            data = <LoadingSection />;
        } else if (exAnteCostList) {
            data = exAnteCostList.map((item, index) => (
                item.get('type')  !== POTENTIAL_COST &&
                    (
                        <BrokerExAntSection
                            context="brokerBuyAdvancedStockExAnte"
                            eventCategory="orden compra fondos/paso 2"
                            section={item}
                            key={index}
                            complexTooltip={true}
                        />
                    )
            ));
            const profitabilityItem = exAnteCostList.find(
                (item) => item.get("type") === "PROFITABILITY"
            );

            if (!!profitabilityItem && showProfitabilitySection) {
                profitabilitySection = this.buildProfitabilitySection(profitabilityItem);
            }

            const potentialSellStocksCosts  = exAnteCostList.find(
                (item) => item.get("descriptionKey") === POTENTIAL_SELL_STOCKS_COSTS
            );

            if (potentialSellStocksCosts && potentialSellStocksCosts.get('type') === POTENTIAL_COST) {
                const dataPotentialCosts = potentialSellStocksCosts.get('details').toJS()[0];
                const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
                const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
                const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
                const formatAmount = `${amount} ${currency}`

                potentialSellStocksCostsText = formatText('brokerBuyAdvancedStockExAnte-exantCost_potentialCost_footer', [formatAmount, immPercentage]);
            }

        }
        return (
            <div className="broker-buy-stock-advanced-description__right-column-container">
                {data}
                <div className="broker-buy-stock-advanced-description__right-column-potential-sell-stocks-container">
                    {potentialSellStocksCostsText}
                </div>
                {profitabilitySection}
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="broker-buy-stock-advanced-description__title-description">
                    {title}
                </div>
                <div className="broker-buy-stock-advanced-description__web-wrapper__extant-cost-container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                <div className="broker-buy-stock-advanced-description__footer">
                    {footer}
                </div>
            </React.Fragment>
        );
    }

    renderExanteDataWeb() {
        const { immBrokerStocksAdvancedBuy } = this.props;
        const dataExtant = immBrokerStocksAdvancedBuy.get('exAnteData');
        const exAnteCostList = !!dataExtant && dataExtant.get('exAnteCostList');
        const potentialSellStockCosts  = exAnteCostList && exAnteCostList.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_STOCKS_COSTS
        );
        return (
            <div className="broker-buy-stock-advanced-description__web-wrapper">
                <div className="broker-buy-stock-advanced-description__web-wrapper__extant-cost-container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                {potentialSellStockCosts && potentialSellStockCosts.get('type') === POTENTIAL_COST_TYPE &&
                    <div className="broker-buy-stock-advanced-description__footer">
                        <FormattedText
                            value="brokerBuyAdvancedStockExAnte-extantCost_footer_description"
                        />
                    </div>
                }
            </div>
        );
    }

    getOrderTermsDescription(unit) {
        const { immBrokerStocksAdvancedBuy, immSearchState } = this.props;
        const step1 = immBrokerStocksAdvancedBuy.get('steps').get(FIRST_STEP);
        const orderTerms = step1.get('orderTerms');
        const orderConditionValue = step1.get('orderConditionValue');
        const stockId = step1.get('stockId');
        const conditionType = step1.get('conditionType');
        let conditionTypeValue;

        let result;

        if (orderTerms === BROKER_RESTRICTED_ORDER_TERM) {
            result = (
                <FormattedText value="broker-advancedBuySellStockSummaryOrderTermsDescription" />
            );
        } else {
            let name;

            if (orderConditionValue === BROKER_STOCK_ORDER_CONDITION_VALUE) {
               const searchList = immSearchState
                    .get('results')
                    .filter(entry => {
                        return (
                            entry.get('type') === BROKER_INPUT_SEARCH_STOCKS_TYPE &&
                            entry.get('value') === stockId
                        );
                    })
                if (!!searchList && !!searchList.get(0)) {
                    name = searchList.get(0).get('label');
                } else {
                    name = BROKER_IBEX35_STOCK_MARKET_NAME;
                }
            } else {
                name = BROKER_IBEX35_STOCK_MARKET_NAME;
            }

            unit = unit.toLowerCase();

            switch (conditionType) {
                case BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = (
                        <FormattedText
                            value="broker-priceGraterOrEqualOrderTermsDescription"
                            injectedStrings={[name, conditionTypeValue, unit]}
                        />
                    );
                    break;
                case BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = <FormattedText value="broker-priceLessOrEqualOrderTermsDescription" injectedStrings={[name, conditionTypeValue, unit]} />
                    break;
                case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-dailyLoweringPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-dailyRasingPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = <FormattedText value="broker-intradayDownVariationGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue, unit]} />
                    break;
                case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-intradayDownVariationPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = (
                        <FormattedText
                            value="broker-intradayUpVariationGraterThanOrderTermsDescription"
                            injectedStrings={[name, conditionTypeValue, unit]}
                        />
                    );
                    break;
                case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = (
                        <FormattedText
                            value="broker-intradayUpVariationPercentageGraterThanOrderTermsDescription"
                            injectedStrings={[conditionTypeValue]}
                        />
                    );
                    break;
                default:
                    result = (
                        <div>
                            {name}
                        </div>
                    );
                    break;
            }
        }

        return (
            <div className="advanced-buy-sell-stock-summary__order-terms-block">
                {result}
            </div>
        );
    }

    buildOrderTerms() {
        const { immBrokerStocksAdvancedBuy } =  this.props;

        const orderTerms = immBrokerStocksAdvancedBuy
            .get('steps')
            .get(FIRST_STEP)
            .get('orderTerms');
        const orderConditionValue = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'orderConditionValue'
        ]);

        let orderTermsText = formatText('broker-advancedBuySellStockSummaryConditionalOrder');
        let orderTermsDescription = this.getOrderTermsDescription(
            orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                ? formatText('broker-pointsText')
                : formatText('currencies-EUR')
        );

        if (orderTerms === BROKER_RESTRICTED_ORDER_TERM) {
            orderTermsText = formatText('broker-advancedBuySellStockSummaryRestrictedOrder');
        }
        return(
            <OKInformativeList>
                <OKInformativeListItem
                    title={formatText('broker-advancedBuySellStockSummaryOrderTypeText')}
                    bodyText={orderTermsText}
                    isUppercaseTitle={true}
                    className="advanced-buy-sell-stock-summary__order-terms-title"
                >
                    {orderTermsDescription}
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }

    renderContent() {
        return (
            __CONTACT_CENTER__ ? (
                <BlockInfo extraClass="broker-buy-stock-advanced-description__block-info">
                    {this.buildOrderTerms()}
                    {this.buildDetails(
                        formatText('brokerBuyAdvancedStockExAnte-extantCost_description_cc'),
                        formatText('brokerBuyAdvancedStockExAnte-extantCost_footer_description_cc')
                    )}
                </BlockInfo>
        ) : (
            <div>
                {this.buildOrderTerms()}
                {this.renderExanteDataWeb()}
            </div>
            )
        )
    }

    render() {
        const { immBrokerStocksAdvancedBuy } = this.props;
        return (
            immBrokerStocksAdvancedBuy.get('exAnteFetching') ? (
                <LoadingSection />
            ) : (
                this.renderContent()
            )
        )
    }
}

BrokerStocksAdvancedBuyExanteCost.propTypes = {
    immBrokerStocksAdvancedBuy: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    showProfitabilitySection: PropTypes.bool.isRequired,
};

module.exports = BrokerStocksAdvancedBuyExanteCost;
